import React from 'react';
import styled from 'styled-components'
import Microsoft from "./Microsoft";

const StyledIcon = styled.svg`
  fill: none;
  width: 20px;
  height: 20px;
  ${props => props.iconStyle && props.iconStyle};
`;

type IconMicrosoftProps = {
    iconStyle?: React.CSSProperties;
    onClick?: () => void;
};

const IconMicrosoft = (props: IconMicrosoftProps) => {
    return (
        <StyledIcon
            iconStyle={props.iconStyle}
            onClick={props.onClick}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
        >
            <Microsoft/>
        </StyledIcon>
    )
};

export default IconMicrosoft;

